import React from 'react';
import { useTranslation } from 'react-i18next';
import { GenericDialog } from 'app/components/Alerts/GenericDialog';

export const RefreshContractPayrollModal = ({
  openDialog,
  handleCancelAction,
  handleConfirmAction,
}: {
  openDialog: boolean;
  handleCancelAction: () => void;
  handleConfirmAction: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <GenericDialog
      open={openDialog}
      maxWidth="sm"
      dialogTitleProps={{
        text: t('placement.placementMods.pendingMods.refreshContractPayrollModal.newContractPayrollTitle'),
        closeButton: true
      }}
      onClose={handleCancelAction}
      dialogActions={[
        {
          text: t('cancelModal.confirmation.cancel'),
          onClick: handleCancelAction,
          variant: 'outlined',
        },
        {
          text: t('cancelModal.confirmation.confirm'),
          onClick: handleConfirmAction,
          variant: 'contained',
        },
      ]}
      dialogActionsProps={{
        sx: { mt: 3 }, // adds gap above the buttons
      }}
      dialogContentProps={{
        content: t('placement.placementMods.pendingMods.refreshContractPayrollModal.newContractPayrollMessage'),
        variant: 'text'
      }}
    >
    </GenericDialog>
  );
};

